import { ExternalLink } from "@/components/icons"

function isUrl(value: string): boolean {
  return /^https?:\/\//i.test(value)
}

function extractDomain(url: string): string {
  try {
    return new URL(url).hostname
  } catch {
    return url
  }
}

type ArgumentValueProps = {
  value: unknown
}

export function ArgumentValue({ value }: ArgumentValueProps) {
  if (typeof value === "string") {
    if (isUrl(value)) {
      return (
        <a
          className="text-primary inline-flex items-center gap-1 hover:underline"
          href={value}
          rel="noopener noreferrer"
          target="_blank"
          onClick={(event) => event.stopPropagation()}
        >
          {extractDomain(value)}
          <ExternalLink className="size-3" />
        </a>
      )
    }
    return <span className="text-foreground">{value}</span>
  }

  if (typeof value === "number" || typeof value === "boolean") {
    return <span className="text-foreground">{String(value)}</span>
  }

  if (Array.isArray(value)) {
    if (
      value.length <= 3 &&
      value.every((item) => typeof item === "string" || typeof item === "number")
    ) {
      return <span className="text-foreground">{value.join(", ")}</span>
    }
    return <span className="text-muted-foreground">{value.length} items</span>
  }

  if (typeof value === "object" && value !== null) {
    return <span className="text-muted-foreground">{Object.keys(value).length} properties</span>
  }

  return <span className="text-foreground">{String(value)}</span>
}
